var exports = {
  "M6": "x43aef4ae--7ef7ec--slide",
  "W$": "x43aef4ae--7ef7ec--slide__media-wrapper",
  "bh": "x43aef4ae--7ef7ec--slide__image",
  "DD": "x43aef4ae--7ef7ec--title",
  "Qs": "x43aef4ae--7ef7ec--content",
  "G8": "x43aef4ae--7ef7ec--main-content",
  "Gv": "x43aef4ae--7ef7ec--avatar-wrapper",
  "VL": "x43aef4ae--7ef7ec--information-container",
  "Ov": "x43aef4ae--7ef7ec--information__wrapper",
  "HE": "x43aef4ae--7ef7ec--button-wrapper",
  "rP": "x43aef4ae--7ef7ec--transports-wrapper",
};

module.exports = exports;
